
const AcademicReadinessData = [
    {
        id: 1,
        bannerImg: require("../../../Assets/Gulf_Students/Academic_Readiness/Time-management.png"),
        text: "Time management & note-taking frameworks"
    },
    {
        id: 2,
        bannerImg: require("../../../Assets/Gulf_Students/Academic_Readiness/Essay-structure.png"),
        text: "Essay structure & citation styles"
    },
    {
        id: 3,
        bannerImg: require("../../../Assets/Gulf_Students/Academic_Readiness/Participation-tips.png"),
        text: "Participation tips for seminars & group projects"
    },
    {
        id: 4,
        bannerImg: require("../../../Assets/Gulf_Students/Academic_Readiness/Academic-integrity.png"),
        text: "Academic integrity and research basics"
    },
    {
        id: 5,
        bannerImg: require("../../../Assets/Gulf_Students/Academic_Readiness/downloadable-planners.png"),
        text: "Includes downloadable planners and writing templates."
    },
];

export default AcademicReadinessData;